<div class="simple-cell" [tiimeTooltip]="value" tooltipHideWithoutEllipsis data-cy="simple-cell">
  {{ value }}
</div>
